<template>
  <div id="app">
    <img src="./assets/logo.png">
    <div v-if="isLogin">
<h2>用户面板</h2>
        账号: {{ nickname }}[{{ uid }}];
        身份: {{ typ }};
        可用余额: {{ amount }};
  
    </div>
    <h2>导航菜单</h2>
    <ul>
    <li><router-link to="/">首页</router-link></li>
    <li>
    <a href="javascript:void(0);" v-if="isLogin" v-on:click="logoff">注销</a>
    <router-link v-else="isLogin" to="/login">登录</router-link>
            </li>
            <li  v-if="isLogin">
            <router-link to="/book">书籍列表</router-link>
            </li>
            <li  v-if="isLogin">
            <router-link to="/user">用户列表</router-link>
            </li>
            <li  v-if="isLogin">
            <router-link to="/logs">查看最新日志</router-link>
            </li>
            <li  v-if="isLogin">
            <router-link to="/ai-account">AI账号</router-link>
            </li>
    </ul>
    <router-view @login_succeed="login_succeed" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
  return {
  isLogin: false,
  };
  },
  mounted() {
  if(sessionStorage.getItem("account") && sessionStorage.getItem("token")) {
  this.isLogin = true;
  this.uid = sessionStorage.getItem("uid") 
  this.nickname = sessionStorage.getItem("nickname") 
  try {
    this.amount = parseInt(sessionStorage.getItem("amount"));
  } catch(e) {
  }
    switch(sessionStorage.getItem("typ")) {
  case "999":
  this.typ = "超级管理";
  this.isSuper = true;
  this.isAdmin = true;
  break;
  case "100":
  this.typ = "管理"; 已选择
  this.isAdmin = true;
    break;
    default:
    this.typ = "代理";
    break;
  } // switch
  }
  },
methods: {
  login_succeed(uid,nickname,account,typ,amount) {
  this.isLogin = true;
  this.uid = uid;
  this.nickname = nickname;
this  .account = account;
this.amount = amount;
switch(typ) {
case 999:
this.typ = "超级管理";
this.isSuper = true;
  this.isAdmin = true;
break;
case 100:
this.typ = "管理";
this.isAdmin = true;
break;
default:
this.typ = "代理";
break;
}
  },
  logoff() {
  sessionStorage.removeItem("uid");
  sessionStorage.removeItem("account");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("typ");
  sessionStorage.removeItem("amount");
  this.isLogin = false;
  this.isSuper = false;
  this.isAdmin = false;
  this.account = "未登录";
  this.typ = "未知";
  this.amount = 0;
  this.$router.push({name:"Login"})
  },
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue